<template>
  <div class="footer d-flex align-center justify-space-around py-2">
    <div
      v-for="item in menus"
      :key="item.name"
    >
      <router-link :to="item.path" :class="`d-flex flex-column align-center justify-center ${item.class} ${selectedMenu === item.name ? 'selected' : ''}`" >
        <HomeIcon v-if="item.name==='farmDashboard'" size="32" :color="selectedMenu === item.name ? '#007e57' : '#ccc'" />
        <FlowerIcon v-if="item.name==='farmHarvest'" size="32" :color="selectedMenu === item.name ? '#007e57' : '#ccc'" />
        <BoxesIcon v-if="item.name==='farmOrderItems'" size="32" :color="selectedMenu === item.name ? '#007e57' : '#ccc'" />
        <MessageIcon v-if="item.name==='farmConversations'" size="32" :color="selectedMenu === item.name ? '#007e57' : '#ccc'" />

        <span :style="{color: selectedMenu === item.name ? '#007e57' : '#ccc'}">{{ $t(item.name) }}</span>
      </router-link>
    </div>
  </div>
</template>

<script>
import HomeIcon from "@/components/icons/HomeIcon.vue";
import FlowerIcon from "@/components/icons/FlowerIcon.vue";
import BoxesIcon from "@/components/icons/BoxesIcon.vue";
import MessageIcon from "@/components/icons/MessageIcon.vue";

export default {
  components: { HomeIcon, FlowerIcon, BoxesIcon, MessageIcon },
  data() {
    return {
      mobile: this.$vuetify.breakpoint.xs,
      menus: [
        { path: "/farm/dashboard", name: "farmDashboard", class: "ga-farm-footer-dashboard" },
        { path: "/farm/harvest", name: "farmHarvest", class: "ga-farm-footer-harvests" },
        { path: "/farm/order_items", name: "farmOrderItems", class: "ga-farm-footer-order_items" },
        { path: "/farm/conversations", name: "farmConversations", class: "ga-farm-footer-conversations" }
      ],
      selectedMenu: "farmDashboard",
    };
  },
  watch: {
    $route(to) {
      this.selectedMenu = to.name;
    }
  },
  mounted() {
    this.selectedMenu = this.$route.name;
  },
  methods: {
    isActive(menu) {
      return this.selectedMenu === menu ? "#007e57" : "#cccccc";
    }
  }
};
</script>

<style scoped>
.footer {
  border: 1px solid #eeeeee;
}

.selected {
  color: #007e57;
}
</style>
